export default __webpack_public_path__ + "static/media/accountuser.2637be4d.svg";